// extracted by mini-css-extract-plugin
module.exports = {"Team":"Team_Team__2Pzvr","TeamName":"Team_TeamName__wCxxL","DarkModeTeam":"Team_DarkModeTeam__6eKUF","TeamMembers":"Team_TeamMembers__12U_s"};